import { render, staticRenderFns } from "./ColorText.vue?vue&type=template&id=787c89a6&lang=pug"
import script from "./ColorText.vue?vue&type=script&lang=ts"
export * from "./ColorText.vue?vue&type=script&lang=ts"
import style0 from "./ColorText.vue?vue&type=style&index=0&id=787c89a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports